import {IconName} from "@fortawesome/pro-regular-svg-icons"

export type IconNameExt = IconName | "accident" | "family" | "disaster" | "handcuff" | "nativeAmerican"

export const iconGroup = {
    accident: [
        {
            icon: ["fal", "user"],
            size: "2x",
            transform: "left-11"
        },
        {
            icon: ["fal", "minus"],
            size: "2x",
            transform: "rotate--30 shrink-8 up-6 left-2"
        },
        {
            icon: ["fal", "minus"],
            size: "2x",
            transform: "shrink-9 up-3 left-1"
        },
        {
            icon: ["fal", "minus"],
            size: "2x",
            transform: "rotate-30 shrink-8 left-2"
        },
        {
            icon: ["fal", "user"],
            size: "2x",
            transform: "right-7"
        }
    ],
    family: [
        {
            icon: ["fal", "male"],
            size: "2x",
            transform: "shrink-2 left-7"
        },
        {
            icon: ["fal", "female"],
            size: "2x",
            transform: "shrink-2 left-1"
        },
        {
            icon: ["fal", "child"],
            size: "2x",
            transform: "shrink-4 down-1 right-6"
        }
    ],
    disaster: [
        {
            icon: ["fal", "home"],
            size: "2x",
            transform: "shrink-2 left-2"
        },
        {
            icon: ["fal", "fire"],
            size: "2x",
            transform: "shrink-6 left-8"
        },
        {
            icon: ["fal", "fire"],
            size: "2x",
            transform: "shrink-6 up-7 right-4"
        }
    ],
    handcuff: [
        {
            icon: ["fas", "square"],
            size: "1x",
            color: "black",
            transform: "up-13 right-2 shrink-8"
        },
        {
            icon: ["far", "circle"],
            size: "2x",
            color: "black",
            transform: "up-6 right-3 shrink-6"
        },
        {
            icon: ["fas", "spinner-third"],
            size: "2x",
            color: "black",
            transform: "rotate--120 shrink-6 left-4 up-2"
        },
        {
            icon: ["fas", "square"],
            size: "1x",
            color: "black",
            transform: "down-2 left-9 shrink-8"
        },
        {
            icon: ["far", "circle"],
            size: "2x",
            color: "black",
            transform: "down-6 left-8 shrink-6"
        }
    ],
    nativeAmerican: [
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "shrink-3 up-9"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "shrink-3 left-3 up-6"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "shrink-3 right-3 up-6"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "shrink-3 left-6 up-3"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "shrink-3 right-6 up-3"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "rotate-180 shrink-3 down-8"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "rotate-180 shrink-3 left-3 down-5"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "rotate-180 shrink-3 right-3 down-5"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "rotate-180 shrink-3 down-2 left-6"
        },
        {
            icon: ["fas", "caret-down"],
            size: "2x",
            transform: "rotate-180 shrink-3 down-2 right-6"
        }
    ]
}

export const colorPalette: { [key: string]: string } = {
    "Gray100": "gray.100",
    "Gray300": "gray.300",
    "Gray500": "gray.500",
    "Gray700": "gray.700",
    "Gray900": "gray.900",
    "Red100": "red.100",
    "Red300": "red.300",
    "Red500": "red.500",
    "Red700": "red.700",
    "Red900": "red.900",
    "Orange100": "orange.100",
    "Orange300": "orange.300",
    "Orange500": "orange.500",
    "Orange700": "orange.700",
    "Orange900": "orange.900",
    "Yellow100": "yellow.100",
    "Yellow300": "yellow.300",
    "Yellow500": "yellow.500",
    "Yellow700": "yellow.700",
    "Yellow900": "yellow.900",
    "Green100": "green.100",
    "Green300": "green.300",
    "Green500": "green.500",
    "Green700": "green.700",
    "Green900": "green.900",
    "Teal100": "teal.100",
    "Teal300": "teal.300",
    "Teal500": "teal.500",
    "Teal700": "teal.700",
    "Teal900": "teal.900",
    "Cyan100": "cyan.100",
    "Cyan300": "cyan.300",
    "Cyan500": "cyan.500",
    "Cyan700": "cyan.700",
    "Cyan900": "cyan.900",
    "Blue100": "blue.100",
    "Blue300": "blue.300",
    "Blue500": "blue.500",
    "Blue700": "blue.700",
    "Blue900": "blue.900",
    "Purple100": "purple.100",
    "Purple300": "purple.300",
    "Purple500": "purple.500",
    "Purple700": "purple.700",
    "Purple900": "purple.900",
    "Pink100": "pink.100",
    "Pink300": "pink.300",
    "Pink500": "pink.500",
    "Pink700": "pink.700",
    "Pink900": "pink.900",
    "Rainbow": "rainbow"
}

export const icons: { [key: string]: IconNameExt } = {
    "Family": "family",
    "faMale": "male",
    "faFemale": "female",
    "faChild": "child",
    "faBaby": "baby",
    "Accident": "accident",

    "faUser": "user",
    "faUserCrown": "user-crown",
    "faUsersCrown": "users-crown",
    "User Graduate": "user-graduate",
    "User Tie": "user-tie",
    "faWheelchair": "wheelchair",

    "Home": "home",
    "Disaster": "disaster",
    "Industry": "industry-alt",
    "faBuilding": "building",
    "faUniversity": "university",
    "faStore": "store",

    "Car side": "car-side",
    "faBus": "bus",
    "faTruck": "truck",
    "faTrain": "train",
    "faShip": "ship",
    "Fighter Jet": "fighter-jet",

    "faSmile": "smile",
    "faFrownOpen": "frown-open",
    "faDizzy": "dizzy",
    "faAngry": "angry",
    "faSadCry": "sad-cry",
    "faTired": "tired",

    "faChevronCircleLeft": "chevron-circle-left",
    "faChevronCircleRight": "chevron-circle-right",
    "faChevronCircleUp": "chevron-circle-up",
    "faChevronCircleDown": "chevron-circle-down",
    "faArrowCircleRight": "arrow-circle-right",
    "faArrowCircleLeft": "arrow-circle-left",

    "faCheck": "check",
    "faCheckCircle": "check-circle",
    "faTimes": "times",
    "faTimesCircle": "times-circle",
    "faBan": "ban",
    "faQuestionCircle": "question-circle",

    "faCoins": "coins",
    "faPiggyBank": "piggy-bank",
    "Hand Holding USD": "hand-holding-usd",
    "Money Bill Wave": "money-bill-wave",
    "faTrophy": "trophy",
    "faTrophyAlt": "trophy-alt",

    "Medkit": "medkit",
    "Briefcase": "briefcase",
    "File Signature": "file-signature",
    "Passport": "passport",
    "faCommentAltEdit": "comment-alt-edit",
    "faCommentsAlt": "comments-alt",

    "Gavel": "gavel",
    "faAward": "award",
    "faMedal": "medal",
    "faBalanceScale": "balance-scale",
    "faBlender": "blender",

    "faBoot": "boot",
    "faFeatherAlt": "feather-alt",
    "faFire": "fire",
    "faUtensilKnife": "utensil-knife",
    "Handcuff": "handcuff",
    "Native American": "nativeAmerican",
}

